import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';

const initialState: any = {
    limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
    data: null,
    pages: 0,
    count: null,
    filters: {
        project: [],
        routeStatusType: [],
        vSupervisor: [],
        supervisor: [],
    },
    vacantCheckboxes: [],
    total: {
        totalIncome: 0,
        totalPlaces: 0,
        totalPlannedWage: 0,
        totalReports: 0,
        totalVisits: 0,
        totalWorkload: 0,
    },
    vacantRoutesInputValues: {
        routeNo: null,
        merch: [],
        visitType: [],
        employeeStatus: null,
        routeStatusType: ['Active', 'ActiveNoVacancy', 'Vacant', 'VacantNoVacancy', 'Replacement']
    },
    updatedData: false,
    vacantRoutesSettings: JSON.parse(
        localStorage.getItem('selectedVacantRoutesTabs') as string
    ) || [
        'project',
        'routeNo',
        'login',
        'routeType',
        'vacancyName',
        'vsv',
        'supervisor',
        'tt',
        'visitsOnWeek',
        'income',
        'plannedWage',
    ],
    vacantCheckboxesList: [],
    isPending: true,
};
export const vacantRoutesSlice = createSlice({
    name: 'vacantRoutes',
    initialState,
    reducers: {
        reducerGetVacantRoutes: (state: Draft<any>, action: PayloadAction<any>) => {
            state.count = action.payload.data.count;
            state.pages = action.payload.data.pages;
            state.total.totalWorkload = action.payload.data.totalWorkload;
            state.total.totalIncome = action.payload.data.totalIncome;
            state.total.totalPlannedWage = action.payload.data.totalPlannedWage;
            state.total.totalReports = action.payload.data.totalReports;
            state.total.totalPlaces = action.payload.data.totalPlaces;
            state.total.totalVisits = action.payload.data.totalVisits;
            state.data = action.payload.data?.data;
        },
        reducerSetPending: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.isPending = action.payload
        },
        reducerSetLimit: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.limit = action.payload
        },
        reducerGetVacantRoutesFilters: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.filters.project = action.payload.data?.project?.map(
                (option: any) => ({
                    value: option.id,
                    label: option.name,
                })
            );
            state.filters.merch = action.payload.data?.merch?.map((option: any) => {
                return {value: option.id, label: option.name};
            });
            state.filters.routeStatusType = Object.entries(action.payload.data?.routeStatusType || {}).map(([key, value]) => ({
                value: key,
                label: value
            }));
            state.filters.vSupervisor = action.payload.data?.vsupervisor?.map(
                (option: any) => ({
                    value: option.id,
                    label: option.name,
                })
            );
            state.filters.supervisor = action.payload.data?.supervisor?.map(
                (option: any) => ({
                    value: option.id,
                    label: option.name,
                })
            );
        },
        reducerVacantRoutesInputValues: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.vacantRoutesInputValues = {...state.vacantRoutesInputValues, ...action.payload}
        },
        reducerVacantRoutesSettings: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.vacantRoutesSettings = action.payload;
        },
        reducerVacantRoutesStatus: (state: Draft<any>, action: PayloadAction<any>) => {
            state.clientsStatus = action.payload;
        },
        reducerVacantRoutesStatusMessage: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.clientsStatusMessage = action.payload;
        },
        reducerSetVacantCheckboxes: (state: Draft<any>, action: PayloadAction<any>) => {
            state.vacantCheckboxes = action.payload;
        },
        reducerSetVacantListCheckboxes: (state: Draft<any>, action: PayloadAction<any>) => {
            state.vacantCheckboxesList = [...state.vacantCheckboxesList, action.payload];
        },
        reducerSetVacantListCheckboxesClear: (state: Draft<any>) => {
            state.vacantCheckboxesList = [];
        },
        reducerUpdatedData: (
            state: Draft<any>,
            action: PayloadAction<any>
        ) => {
            state.updatedData = action.payload
        },
        reducerVacantRouteslClearInputValues: (
			state: Draft<any>,
		) => {
            state.vacantRoutesInputValues =  {
                routeNo: null,
                merch: [],
                visitType: [],
                employeeStatus: null,
                routeStatusType: ['Active', 'ActiveNoVacancy', 'Vacant', 'VacantNoVacancy', 'Replacement', 'ReplacementNoVacancy' ]
            };
        }
    },
});

export const {
    reducerGetVacantRoutes,
    reducerGetVacantRoutesFilters,
    reducerVacantRoutesInputValues,
    reducerVacantRoutesSettings,
    reducerVacantRoutesStatus,
    reducerVacantRoutesStatusMessage,
    reducerSetVacantCheckboxes,
    reducerSetVacantListCheckboxes,
    reducerSetVacantListCheckboxesClear,
    reducerSetPending,
    reducerSetLimit,
    reducerUpdatedData,
    reducerVacantRouteslClearInputValues
} = vacantRoutesSlice.actions;

export default vacantRoutesSlice.reducer;
